module.exports = __webpack_public_path__ + "assets/img/rooms.9ccd9b30.svg";